import React from 'react';
import { AuthDIProvider } from '@/features/auth/infra/di/AuthDIContext';
import { SectionOneDIProvider } from '@/features/section-1/infra/di/SectionOneDIContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { DashboardDIProvider } from '@/features/dashboard/infra/di/DashboardDIContext';
import { PendingSection2DIProvider } from '@/features/pending_section2/infra/di/PendingSection2DIContext';
import { PendingSsnDIProvider } from '@/features/pending_ssn/infra/di/PendingSsnDIContext';
import { ActiveI9DIProvider } from '@/features/active_i9_queue/infra/di/ActiveI9DIContext';
import { DuplicateCaseDIProvider } from '@/features/duplicate_cases/infra/di/DuplicateCaseDIContext';
import { TncDIProvider } from '@/features/pending_dhs_ssa_cases/features/tnc/infra/di/TncDIContext';
import { CaseCloseDIProvider } from '@/features/case_close/infra/di/CaseCloseDIContext';
import { Section2DIProvider } from '@/features/section-2/infra/di/Section2DIContext';
import { I9FormViewerDIProvider } from '@/features/i9_form_viewer/infra/di/I9FormViewerDIContext';
import { AmendmentDIProvider } from '@/features/amendment/infra/DI/amendmentDIContext';
import { EmployeeRecordDIProvider } from '@/features/employee_record/infra/di/EmployeeRecordDIContext';
import { PendingSection1DIContextProvider } from '@/features/pending_section1/infra/di/PendingSection1DIContext';

const queryClient = new QueryClient();
export const AppDIProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    <AuthDIProvider>
      <AmendmentDIProvider>
        <SectionOneDIProvider>
          <DashboardDIProvider>
            <PendingSection2DIProvider>
              <PendingSsnDIProvider>
                <ActiveI9DIProvider>
                  <PendingSection1DIContextProvider>
                    <Section2DIProvider>
                      <EmployeeRecordDIProvider>
                        <TncDIProvider>
                          <DuplicateCaseDIProvider>
                            <CaseCloseDIProvider>
                              <I9FormViewerDIProvider>{children}</I9FormViewerDIProvider>
                            </CaseCloseDIProvider>
                          </DuplicateCaseDIProvider>
                        </TncDIProvider>
                      </EmployeeRecordDIProvider>
                    </Section2DIProvider>
                  </PendingSection1DIContextProvider>
                </ActiveI9DIProvider>
              </PendingSsnDIProvider>
            </PendingSection2DIProvider>
          </DashboardDIProvider>
        </SectionOneDIProvider>
      </AmendmentDIProvider>
    </AuthDIProvider>
  </QueryClientProvider>
);
